import { render, staticRenderFns } from "./DashboardCardProperties.vue?vue&type=template&id=cbcd5904&"
import script from "./DashboardCardProperties.vue?vue&type=script&lang=js&"
export * from "./DashboardCardProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports